module.exports = __webpack_public_path__ + "static/media/soles_sponsorship_packet_2025-2026.1262ed04.pdf";